module.exports = __webpack_public_path__ + "static/media/icon-replay-youtube.1d5534e1.svg";